module.exports = __webpack_public_path__ + "img/school_active.a79bfb5c.svg";